import TemplateState from "@/modules/conversation-template";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const OpenCloseResolver = async function (to: Route, from: Route, next: Function) {
	const templateModule = getModule(TemplateState);
	const actions: Promise<void>[] = [];

	if (!templateModule.conversationTags.length) {
		actions.push(templateModule.fetchConversationTags());
	}

	await Promise.all(actions);
	next();
};
